// extracted by mini-css-extract-plugin
export default {"Reachability":"Reachability_Reachability__xES5z","Reachability__loader":"Reachability_Reachability__loader__eBC-j","lds-dual-ring":"Reachability_lds-dual-ring__UetA4"};